/**
 * useDepartments
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import DepartmentsContext from './departments-context'

const useDepartments = () => {
  const context = useContext(DepartmentsContext)
  return context
}

export default useDepartments
